import { toast } from 'sonner';

/**
 * Copy a view link to the clipboard and tell the rep how it went — the ONE
 * clipboard + toast path behind every "Copy link": the view machine's own
 * `copyLink`, `SavedViewsPane`'s foreign-entity rows, and V1
 * `BrowseAllModal`. Callers build the (absolute) `href`; this never throws —
 * a refused clipboard shows the link itself so the rep can copy it by hand.
 */
export async function copyViewLink(href: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(href);
    toast.success('Link copied — anyone at Clay can open this view');
  } catch {
    toast.error(`Couldn't copy automatically — the link is ${href}`);
  }
}
